import './loader.css'

const Loader = (props: any) => {
  return (
    <div className='loading d-flex justify-content-center w-100'>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
}
export default Loader
